function moveBot() {
    const chatbot = document.querySelector(".chatbot");
    const botImg = document.querySelector(".bot");

    if (!chatbot && !botImg) return;

    setInterval(() => {
        const isGoingToView2 = chatbot.classList.contains("view-1");

        if (isGoingToView2) {
            botImg.classList.add("look-right");
            chatbot.classList.remove("view-1");
            chatbot.classList.remove("show");
            chatbot.classList.add("view-2");

            setTimeout(() => {
                chatbot.classList.add("show");
            }, 2500);
        } else {
            chatbot.classList.remove("view-2");
            chatbot.classList.remove("show");
            chatbot.classList.add("view-1");
        }

        setTimeout(() => {
            botImg.classList.remove("look-right");
        }, 2000);
    }, 10000);
}
moveBot();
